import clsx from 'clsx';

import { ProductShape } from 'lib/util/productShape';

import { useTranslation } from 'react-i18next';

import { ContentSection } from './ContentSection/ContentSection';
import baseStyles from '../base.module.css';
import styles from './ProductDetailsView.module.css';

type Props = {
  product: ProductShape;
};

export const HighlightsView = ({ product }: Props) => {
  const { t } = useTranslation();

  if ((product.highlights ?? []).length === 0) {
    return null;
  }

  return (
    <ContentSection
      title={t('Highlights')}
      englishTitle="Highlights"
      className={styles['highlight']}
    >
      <ul className={styles['highlight__list']}>
        {product.highlights.map((highlight, idx) => (
          <li className={styles['highlight__list__item']} key={idx}>
            <div
              className={clsx(
                styles['highlight__list__item__point'],
                baseStyles['color-bg--black'],
                baseStyles['color-txt--white']
              )}
            >
              <p>POINT</p>
              <p>{idx + 1}</p>
            </div>
            <p className={styles['highlight__list__item__desc']}>{highlight}</p>
          </li>
        ))}
      </ul>
    </ContentSection>
  );
};
